import { render, staticRenderFns } from "./LandsideFooterSection.vue?vue&type=template&id=5f212cd2&scoped=true&"
import script from "./LandsideFooterSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LandsideFooterSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LandsideFooterSection.vue?vue&type=style&index=0&id=5f212cd2&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f212cd2",
  null
  
)

export default component.exports